!function(name, module, context) {
	// >>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('common/sorter',['ct_utils'], module)
	else
		// >>excludeEnd("requireTmpl");
		context[name] = module()
}('sorter', function() {

	var commonSorter = {
		sortAsc : function(dataList, altVal, obj) {
			
			try{ 
			var sortedData = _.sortBy(dataList, function(eachli) {
				s = eachli.getAttribute("data-" + obj[altVal]);
				return (altVal === 'airline') ? s : -s;
			});
			}
			catch(e){
				_errs.push(e);
			}
			
			return sortedData;
		},

		
		
		sortDesc : function(dataList, altVal,obj) {
			
			try{ 
			var sortedData = _.sortBy(dataList, function(eachli) {
				s = eachli.getAttribute("data-" + obj[altVal]);
				return (altVal === 'airline') ? s : +s;
			});
			}
			catch(e){
				_errs.push(e);
			}
			
			return sortedData;
		},
		
		getSorterParams : function(paramsHash){
			var params = paramsHash || _.deserialize(window.location.search.substr(1));
			return { id : params.sort, order : params.sort_order };
		}
	}
	return commonSorter;
}, CT.settings);
